import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function FinalCTA() {
  const cartUrl = 'https://competirsinmiedo.com/cart/add?id=45092891263029&quantity=1';
  return <section className="py-20 md:py-28 bg-[#1a1a2e] relative overflow-hidden text-center" data-id="element-42">
      <div className="absolute inset-0 opacity-5 bg-[url('https://images.unsplash.com/photo-1518605368461-1e1e111e1ebc?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80')] bg-cover bg-center mix-blend-overlay" data-id="element-43"></div>

      <div className="max-w-3xl mx-auto px-5 sm:px-6 lg:px-8 relative z-10" data-id="element-44">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} data-id="element-45">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading text-white mb-6 leading-tight" data-id="element-46">
            Ayuda a tu hijo a recuperar su confianza, disfrutar otra vez del
            fútbol y competir con más fortaleza mental.
          </h2>

          <p className="text-base md:text-lg text-white/80 mb-10 leading-relaxed" data-id="element-47">
            Accede ahora a Competir sin Miedo.
          </p>

          <a href={cartUrl} onClick={trackAddToCart} className="inline-flex justify-center items-center px-8 py-4 text-base md:text-lg font-semibold text-white bg-brand-amber hover:bg-brand-amber-dark rounded-xl transition-colors duration-200 w-full sm:w-auto" data-id="element-48">
            Quiero Acceder Ahora →
          </a>
          <p className="text-white/60 font-medium text-sm mt-4 tracking-wide" data-id="element-49">
            La confianza de tu hijo empieza con este clic
          </p>

          <div className="mt-10 flex items-center justify-center text-white/60 text-sm gap-2" data-id="element-50">
            <ShieldCheckIcon className="w-4 h-4 text-white/40" data-id="element-51" />
            <span data-id="element-52">Garantía de satisfacción incluida. Pago 100% seguro.</span>
          </div>
        </motion.div>
      </div>
    </section>;
}